


















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class DrawerComponent extends Vue {
  @Prop({
    type: Boolean,
    required: true,
  }) value!: boolean;

  @Prop({
    type: String,
    default: '65%',
  }) width!: string;

  @Prop({
    type: String,
    default: 'Salvar',
  }) saveButtonText!: string;

  @Prop({
    type: String,
    default: 'Fechar',
  }) closeButtonText!: string;

  @Prop({
    type: Boolean,
    default: false,
  }) showSaveButton!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) loadingSave!: boolean;
}
